import { observer } from 'mobx-react-lite'
import { useMemo } from 'react'
import { Table } from 'shared/ui/TableNew'
import type { RowConversion } from 'entities/Analytics/model/Table/rowConversion'
import { useEntitiesContext } from 'entities/EntitiesExport'
import { useConversionsAnalyticsListContext } from 'pages/analytics/pages/conversions/context/conversionsAnalyticsListContext'
import { AnalyticsRoutes } from 'pages/analytics'
import { getConversionActions } from 'pages/analytics/pages/conversions/ui/ConversionsTable/getConversionActions'
import { getColumns } from './getColumns'

export const ConversionsTable = observer(() => {
  const {
    conversionsTableStore: { tableStore, conversionsRows, loadConversions },
  } = useConversionsAnalyticsListContext()
  const entities = useEntitiesContext()

  const columns = useMemo(() => getColumns(), [])

  const getRowLink = (row: RowConversion) =>
    `/${AnalyticsRoutes.root}/${AnalyticsRoutes.conversions}/${row.id}`

  const rows = useMemo(
    () =>
      conversionsRows.map((row) => {
        row.setActionsProps({
          actions: getConversionActions(row, entities, () => loadConversions()),
        })
        return row
      }),
    [conversionsRows]
  )

  return (
    <Table
      ariaLabel={'ConversionsTable'}
      store={tableStore}
      columns={columns}
      rows={rows}
      getRowLink={getRowLink}
      emptyStateProps={{
        text: 'No conversions data found',
        noIcon: true,
      }}
    />
  )
})
